var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from '../../styled';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const generateHoverStyle = () => {
    return css `
    &:hover {
      cursor: pointer;
      box-shadow: 0 0 1rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT},
        0 0.0625rem 0.1875rem 0 ${({ theme }) => theme.colors.SHADOW_DARK};
    }
  `;
};
const CardWrapper = styled.div `
  border-radius: 4px;
  box-shadow: 0 0.0625rem 0.1875rem 0
      ${({ theme }) => theme.colors.SHADOW_LIGHT},
    0 0 0.0625rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT};
  background-color: ${({ theme }) => theme.colors.SNOW_200};
  padding: 1.5rem;
  transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;

  ${props => props.hoverable && generateHoverStyle()}
`;
const Title = styled.div `
  margin-bottom: 1.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.INK_800};
`;
const Content = styled.div `
  font-size: 0.875rem;
  line-height: 1.57;
  color: ${({ theme }) => theme.colors.INK_800};
`;
const Card = (_a) => {
    var { title, content, children, hoverable = false, innerRef } = _a, restProps = __rest(_a, ["title", "content", "children", "hoverable", "innerRef"]);
    return (React.createElement(CardWrapper, Object.assign({ hoverable: hoverable }, restProps, { ref: innerRef }),
        title && React.createElement(Title, null, title),
        content && React.createElement(Content, null, content),
        children));
};
export default React.forwardRef((props, ref) => React.createElement(Card, Object.assign({ innerRef: ref }, props)));
//# sourceMappingURL=index.js.map